import moment from "moment";

export const getFormattedDate = (dateCreated: any, language: any) => {
    const date = new Date(dateCreated);
    date.setTime(date.getTime() - 10000);
    if (moment(date).isBefore(moment().subtract(1, 'days'))) {
        return moment(date).locale(language).format('DD.MM.YYYY, HH:mm');
    }
    return moment(date).locale(language).fromNow();
}import moment from "moment";

export const getFormattedDate = (dateCreated: any, language: any) => {
    const date = new Date(dateCreated);
    date.setTime(date.getTime() - 10000);
    if (moment(date).isBefore(moment().subtract(1, 'days'))) {
        return moment(date).locale(language).format('DD.MM.YYYY, HH:mm');
    }
    return moment(date).locale(language).fromNow();
}